import React from 'react';

import useCurrencyFormatter from '../../CurrencyFormatterContext';

export const CurrencyCell: React.FC<{ value?: number | null }> = ({ value }) => {
  const { currencyFormatter } = useCurrencyFormatter();

  return <div>{typeof value === 'number' ? currencyFormatter.format(value) : ''}</div>;
};
